import React, { useEffect, useRef } from 'react'
import styled from 'styled-components'

import { SHOWCASE_DEMO_VIDEO_URL } from './Showcase/showcaseContent'

/** Minimal fullscreen video page at `/video` — black letterbox, autoplay loop. */
const VideoPage = () => {
	const videoRef = useRef<HTMLVideoElement>(null)

	useEffect(() => {
		const el = videoRef.current
		if (!el) return

		el.muted = true
		el.currentTime = 0
		void el.play().catch(() => {
			// Autoplay may be blocked; controls are not shown, so the page stays quiet.
		})

		return () => {
			el.pause()
		}
	}, [])

	return (
		<Stage>
			<Video
				ref={videoRef}
				autoPlay
				muted
				loop
				playsInline
				preload="auto"
				src={SHOWCASE_DEMO_VIDEO_URL}
				aria-label="Micromart Smart Store overview video"
			/>
		</Stage>
	)
}

const Stage = styled.div`
	position: fixed;
	inset: 0;
	width: 100vw;
	height: 100vh;
	background: #000;
	display: flex;
	align-items: center;
	justify-content: center;
	overflow: hidden;
`

const Video = styled.video`
	width: 100%;
	height: 100%;
	object-fit: contain;
	display: block;
`

export default VideoPage
